import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { HEADER_HEIGHT } from 'global/config';

export const Backdrop = styled.div<{
  visible: boolean;
}>`
  z-index: -2;
  position: fixed;
  top: ${HEADER_HEIGHT}px;
  left: 0;
  display: ${({ visible }) => (visible ? 'block' : 'none')};
  width: 100%;
  height: 100vh;
  pointer-events: auto;
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);

  background-color: rgba(0, 0, 0, 0.6);

  html[data-theme='dark'] &&,
  .dark && {
    background-color: rgba(0, 0, 0, 0.4);
  }
`;

export const PopoverBackground = styled.summary`
  z-index: -1;
  list-style: none;
  position: fixed;
  top: ${HEADER_HEIGHT}px;
  left: 0;

  // For Safari

  &::-webkit-details-marker {
    display: none;
  }

  background: ${themeStyle.varBackgroundAlt};
  box-shadow: ${themeStyle.varShadowMedium};
  width: 100%;
`;

export const PopoverContentWrapper = styled.div<{
  visible: boolean;
  additionalPadding?: string;
}>`
  padding-top: ${({ additionalPadding }) =>
    additionalPadding ? additionalPadding : 'none'};
  display: ${({ visible }) => (visible ? 'block' : 'none')};
`;
